export enum IRecommendItemType {
  Product = 'product',
  Activity = 'activity',
}

export type IRecommendItemDTO =
  | {
      type: IRecommendItemType.Product;
      commodityId: number;
      text: string;
      urlKey: string;
    }
  | {
      type: IRecommendItemType.Activity;
      activityLink: string;
      text: string;
    };

export interface IRecommendListDTO {
  category: string;
  recommendItems: IRecommendItemDTO[];
  type: IRecommendItemType;
}
